/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Create_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Create new project" |
*
* @param {New_Project_Create_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_create_aria_label = /** @type {((inputs?: New_Project_Create_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Create_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Creer un nouveau projet")
	if (locale === "de") return /** @type {LocalizedString} */ ("Neues Projekt erstellen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Crea un nuovo progetto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Создать новый проект")
	if (locale === "es") return /** @type {LocalizedString} */ ("Crear nuevo proyecto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("创建新项目")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新しいプロジェクトを作成する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नया प्रोजेक्ट बनाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Criar novo projeto")
	return /** @type {LocalizedString} */ ("Create new project")
});